module.exports = __webpack_public_path__ + "static/img/2-企业简介背景图.a98198e0.jpg";